/**
 * Utilitários puros para o rótulo de SLA/prazo (`sla_label`) do BP.
 * Centraliza a normalização/exibição usada em mais de uma tela (listagem de
 * Business Plans e cards de Acompanhamento), evitando regras duplicadas
 * (ex.: `toLowerCase() === "aprovado"` → "Finalizado").
 */

/**
 * Normaliza o `sla_label` vindo do backend para comparação consistente
 * (trim + caixa baixa).
 * @param {string|null|undefined} label
 * @returns {string}
 */
export function normalizeSlaLabel(label) {
  return typeof label === "string" ? label.trim().toLowerCase() : "";
}

/** Mapeamento de exibição por valor normalizado de `sla_label`. */
export const SLA_LABEL_EXIBICAO = {
  aprovado: "Finalizado"
};

/**
 * Retorna o rótulo de exibição do `sla_label` (ex.: `aprovado` → "Finalizado").
 * Valores sem regra de exibição retornam o label original (null incluso).
 * @param {string|null|undefined} label
 * @returns {string|null|undefined}
 */
export function slaLabelExibicao(label) {
  const chave = normalizeSlaLabel(label);
  return SLA_LABEL_EXIBICAO[chave] || label;
}

/** Paleta usada para colorir o `sla_label` nas telas. */
export const SLA_LABEL_CORES = {
  aprovado: "#6BB4BA",
  reprovado: "#FF4040",
  atrasado: "#EC4C47",
  padrao: "#FFC440"
};

/**
 * Cor do texto do SLA no card (aprovado/atrasado têm cor própria;
 * demais valores voltam null e herdam o CSS).
 * @param {string|null|undefined} label
 * @returns {string|null}
 */
export function slaLabelCorTexto(label) {
  const chave = normalizeSlaLabel(label);

  if (chave === "aprovado") {
    return SLA_LABEL_CORES.aprovado;
  }

  if (chave === "atrasado") {
    return SLA_LABEL_CORES.atrasado;
  }

  return null;
}

/**
 * Cor do "status" do workflow no card (aprovado/reprovado têm cor própria;
 * demais valores usam a cor padrão).
 * @param {string|null|undefined} label
 * @returns {string}
 */
export function slaLabelCorStatus(label) {
  const chave = normalizeSlaLabel(label);

  if (chave === "aprovado") {
    return SLA_LABEL_CORES.aprovado;
  }

  if (chave === "reprovado") {
    return SLA_LABEL_CORES.reprovado;
  }

  return SLA_LABEL_CORES.padrao;
}
